import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import countries from 'i18n-iso-countries';
import _ from 'lodash';
import english from 'i18n-iso-countries/langs/en.json';
import { Button } from 'react-bootstrap';

import {
  validate,
  format,
  TextField,
  SelectField,
  attachRefToFields,
} from '../Form';


countries.registerLocale(english);

const countriesOptions = Object.entries(countries.getNames('en')).map(
  i => ({ value: i[0], label: i[1] })
);

class LocationDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      location = {},
      orgId,
    } = this.props;

    const {
      error = '',
    } = this.state;

    const fields = {
      name: '', // required
      address_one: '', // create
      address_two: '', // create
      city: '', // required
      state: '', // create
      postal: '', // create
      country: '', // required
      timezone: '', // required
      created_by: '', // create
      modified_by: '', // update
      org_id: orgId, // required
      phone: '', // create
      mobile: '', // create
      fax: '', // create
      notes: '', // create
      config: {}, // create
      ..._.omitBy(location, _.isNil),
    };

    return (
      <div className='detail'>
        <Formik
          initialValues={{
            ...fields,
            country: 'US',
          }}
          ref={(c) => { this.form = c; }}
          enableReinitialize
          validate={values => validate(this, values)}
          onSubmit={async (values, { setSubmitting, setErrors }) => { // eslint-disable-line
            let newValues = values;

            try {
              newValues = await format(this, values);
            } catch (err) {
              console.error(err); // eslint-disable-line
              this.setState({
                error: 'An unknown error occured',
              });
              return;
            }
            setSubmitting(true);
            let resp;
            try {
              resp = await this.props.update(newValues);
            } catch (err) {
              this.setState({
                error: err.message,
              });
            }
            setSubmitting(false);
            return resp;
          }}
          render={(props) => { // eslint-disable-line
            const page = this;
            return (
              <React.Fragment>
                <div className='title'>{location.name} - <small>{location.city}</small></div>
                {error ? <div className='alert alert-danger'>{error}</div> : null}
                <form onSubmit={props.handleSubmit}>
                  <div className='form-group'>
                    <div className='row section'>
                      <TextField
                        type='text'
                        name='name'
                        label='Name'
                        required
                        ref={attachRefToFields.bind(this, page)}
                        {...props}
                      />
                    </div>
                    <div className='row section'>
                      <TextField
                        type='text'
                        name='address_one'
                        label='Address 1'
                        required
                        ref={attachRefToFields.bind(this, page)}
                        {...props}
                      />
                    </div>
                    <div className='row section'>
                      <TextField
                        type='text'
                        name='address_two'
                        label='Address 2'
                        ref={attachRefToFields.bind(this, page)}
                        {...props}
                      />
                    </div>
                    <div className='row section'>
                      <TextField
                        type='text'
                        name='city'
                        label='City'
                        required
                        ref={attachRefToFields.bind(this, page)}
                        {...props}
                      />
                    </div>
                    <div className='row section'>
                      <TextField
                        type='text'
                        name='state'
                        label='State'
                        required
                        ref={attachRefToFields.bind(this, page)}
                        {...props}
                      />
                    </div>
                    <div className='row section'>
                      <TextField
                        type='text'
                        name='postal'
                        label='Postal'
                        required
                        ref={attachRefToFields.bind(this, page)}
                        {...props}
                      />
                    </div>
                  </div>
                  <div className='row section'>
                    <SelectField
                      name='country'
                      label='Country'
                      required
                      options={countriesOptions}
                      handleBlur={() => true}
                      handleChange={() => true}
                      ref={attachRefToFields.bind(this, page)}
                      {...props}
                    />
                  </div>
                </form>
                <div className='actions'>
                  <span>
                    <Button
                      bsStyle='primary'
                      onClick={() => {
                        props.submitForm();
                      }}
                    >
                      Add Location
                    </Button>
                  </span>
                  <span>
                    <Button bsStyle='danger' onClick={this.props.close}>
                      Cancel
                    </Button>
                  </span>
                </div>
              </React.Fragment>
            );
          }}
        />
        <div className='footer-gradient' />
      </div>
    );
  }
}

LocationDetail.propTypes = {
  orgId: PropTypes.string,
  location: PropTypes.shape({}),
  locations: PropTypes.instanceOf(Array),
  update: PropTypes.func.isRequired,
  close: PropTypes.func,
};

LocationDetail.defaultProps = {
  orgId: '',
  location: {},
  locations: [],
  close: () => {},
};

export default LocationDetail;



// WEBPACK FOOTER //
// ./src/views/Components/Detail/LocationDetail.js